import { ReactElement } from 'react';
import { S_Card } from '../../../design/card/card/S_Cards';
import { DashboardContainer } from '../../../modules/common/dashboard/DashboardContainer';
import { HeaderWithDescription } from '../../../modules/common/headerWithDescription/HeaderWithDescription';
import { ColumnLayout } from '../../../modules/common/layouts/columnLayout/ColumnLayout';
import { WorkspaceListSearchContainer } from '../../modules/workspaces/containers/WorkspaceListSearch.container';
import { WorkspacesListContainer } from '../../modules/workspaces/containers/WorkspacesList.container';

export const WorkspacesView = (): ReactElement => (
  <DashboardContainer>
    <HeaderWithDescription header='Workspaces' />
    <S_Card>
      <ColumnLayout size='md'>
        <WorkspaceListSearchContainer />
        <WorkspacesListContainer />
      </ColumnLayout>
    </S_Card>
  </DashboardContainer>
);
